module.exports = __webpack_public_path__ + "img/Кропова-Ольга-Евгеньевна.ad4a9316.png";